import { SIGN_IN, SIGN_OUT, REFRESH_SUCCESS, REFRESH_FAIL } from '../actions/types';
import Cookies from 'js-cookie';

const INITIAL_STATE = {
    isSignedIn: Cookies.get('logged_in') ? true: false,
    id: null,
    customer_id: null,
    firstname: null,
    lastname: null,
    role: null,
    scopes: [],
    email: null,
    auth_flow: null,
    accessToken: null,
    isRefreshing: true
};

const authReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SIGN_IN:
            return { ...state, isSignedIn: true, id: action.payload.id, customer_id: action.payload.customer_id, firstname: action.payload.firstname, lastname: action.payload.lastname, role: action.payload.role, scopes: action.payload.scopes, email: action.payload.email, auth_flow: action.payload.auth_flow, accessToken: action.payload.accessToken };
        case SIGN_OUT:
            return { ...state, isSignedIn: false, id: null, customer_id: null, firstname: null, lastname: null, email: null, auth_flow: null, accessToken: null };
        case REFRESH_SUCCESS:
            return { ...state, isSignedIn: true, id: action.payload.id, customer_id: action.payload.customer_id, firstname: action.payload.firstname, lastname: action.payload.lastname, role: action.payload.role, scopes: action.payload.scopes, email: action.payload.email, auth_flow: action.payload.auth_flow, accessToken: action.payload.accessToken, isRefreshing: false };
        case REFRESH_FAIL:
            return { ...state, isSignedIn: false, id: null, customer_id: null, firstname: null, lastname: null, role: null, scopes: [], email: null, auth_flow: null, accessToken: null };
        default:
            return state;
    }
};

export default authReducer